import { AuthService as authService } from "@common/auth.service";
import * as _ from "lodash";
import { Roles } from "@common/enums/Roles";

class NavigationController {
  auth: any;

  get userName(): string {
    return this.authService.getUserName();
  }

  /** @ngInject */
  constructor(
    private authService: authService,
    private $timeout: angular.ITimeoutService,
    private $state: angular.ui.IStateService
  ) {
    var _this = this;
    _this.auth = authService;
  }

  userHasAccess(functionality: string) {
    var functionalityToRoleMap = {};
    functionalityToRoleMap["clients"] = [
      Roles.PortfolioTeam,
      Roles.ViewOnly,
      Roles.ClientDetailsViewOnly,
      Roles.SystemAdministrator,
      Roles.SeniorManagement,
    ];
    functionalityToRoleMap["cmodel"] = [
      Roles.FinancialAnalyst,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
      Roles.PortfolioTeam,
    ];
    functionalityToRoleMap["portfolio"] = [
      Roles.Client,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
      Roles.SeniorManagement,
    ];
    functionalityToRoleMap["performance"] = [
      Roles.PortfolioTeam,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["reports"] = [
      Roles.Client,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["transactions"] = [
      Roles.PortfolioTeam,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["contact_us"] = [
      Roles.Client,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["users"] = [
      Roles.UserAdministrator,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["portfolioManagement"] = [
      Roles.PortfolioTeam,
      Roles.ViewOnly,
      Roles.ClientDetailsViewOnly,
      Roles.SystemAdministrator,
      Roles.SeniorManagement,
    ];
    functionalityToRoleMap["trading"] = [
      Roles.PortfolioTeam,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
      Roles.SeniorManagement,
    ];
    functionalityToRoleMap["tradingAdmin"] = [
      Roles.TradingAdministrator,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
      Roles.SeniorManagement,
    ];
    functionalityToRoleMap["accountant"] = [
      Roles.Accountant,
      Roles.SeniorAccountant,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["reportingSummary"] = [
      Roles.SeniorManagement,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["compliance"] = [
      Roles.Compliance,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["fileproviders"] = [
      Roles.UserAdministrator,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["application"] = [
      Roles.UserAdministrator,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];
    functionalityToRoleMap["personaldetails"] = [
      Roles.Client,
      Roles.ViewOnly,
      Roles.SystemAdministrator,
    ];

    

    var roles = this.authService.getUserRoles() as Array<string>;
    if (functionalityToRoleMap[functionality] == null) return true;
    
    // If roles is empty, deny access
    if (!roles || roles.length === 0) return false;

    if (_.intersection(roles, functionalityToRoleMap[functionality]).length > 0)
      return true;

    return false;
  }

  logout() {
    this.auth.logout();
  }
  collapseSidebar_smallScreen() {
    document.getElementById("mySidebar").style.display = "none";
  }
  displayUATBanner() {
    return location.hostname.includes("uat");
  }

  navigateToPortfolioManagement() {
    // If user has ClientDetailsViewOnly role, redirect to clients page
    if (this.authService.isClientDetailsViewOnly()) {
      this.$state.go("root.portfolioManagement.clients");
    } else {
      this.$state.go("root.portfolioManagement");
    }
  }
}

export const navigation: angular.IComponentOptions = {
  template: require("./navigation.html"),
  controller: NavigationController,
};



// WEBPACK FOOTER //
// ./src/app/layout/navigation.ts